// FUNÇÕES/MÓDULOS SITE

// Layout
import Header from './modules/Layouts/header'
import Footer from './modules/Layouts/footer'

// Animations
import HoverBackgroundGradient from './modules/Animation/hover_bg-gradient'
import AnimationElements  from './modules/Animation/enterElements'
import ImageEnter from './modules/Animation/imageEnter'
import ImagesHovers from './modules/Animation/imageHovers'
import AnimationsElements from './modules/Animation/animation'
import ScrollSmooth from './modules/Animation/scrollLenis'

// Utils
import infinityText from './modules/Utils/infinityText'

// Layout
Header()
Footer()

// Animations
HoverBackgroundGradient()
AnimationElements()
ImageEnter()
ImagesHovers()
AnimationsElements()
ScrollSmooth()

// Utils
infinityText()
